// eslint-disable-next-line
import {
  getMessages,
  getCountMessages,
  updateCountMessages,
  getTask,
  getActiveNewsletter,
  setNewsletterAsSeen,
} from '@/api/index';

export default {
  namespaced: true,
  state() {
    return ({
      messagesList: [],
      showMessages: false,
      count: 0,
      taskInforamtion: {},
      newsList: [],
      showNews: false,
      newsCount: 0,
    });
  },
  getters: {
    
  },
  mutations: {
    setLoading(state, status) {
      state.loadingUsers = status;
    },
    changeContainer(state, status ){
      state.showMessages = status;
    },
    setCount(state, count ){
      state.count = count;
    },
    setMessagesList(state, list ){
      state.messagesList = list;
    },
    setTaskData(state, task ){
      state.taskInforamtion = task;
    },
    setNewsList(state, list){
      state.newsList= list;
    },
    setNewsCount(state, count){
      state.newsCount = count;
    },
    setShowNews(state, status){
      state.showNews = status;
    },
  },
  actions: {
    async apiGetMessages({
      commit,
    }) {
      await getMessages().then((res) => {
        commit('setMessagesList', res);
      });
    },


    async apiGetCountMessages({
      commit,
    }) {
      await getCountMessages().then((res) => {
        commit('setCount', res.count);
      });
    },
    async apiUpdateCountMessages({
      commit,
      state,
    }) {
      if( state.count > 0 ){
        await updateCountMessages().then((res) => {
          commit('setCount', 0);
        });
      }
    },

    async apiGetTask({
      commit,
    },taskId) {
      await getTask(taskId).then((res) => {
        commit('setTaskData', res);
      });
    },

    async apiGetNews({
      commit,
    }) {
      await getActiveNewsletter().then((res) => {
        commit('setNewsList', res.news);
        commit('setNewsCount', res.total_unseen);
      });
    },

    async apiSetNewsAsSeen({
      commit,
      state,
    }, newsletterId) {
      await setNewsletterAsSeen(newsletterId);
      if(state.newsCount > 0){
        commit('setNewsCount', state.newsCount - 1);
      }
    },

    async apiSetAllSeen({
      commit,
      state,
    }) {
      let unseen = state.newsList.filter(x => x.seen == false);
      if(unseen && unseen.length > 0){
        for(let i = 0; i < unseen.length; i++){
          setNewsletterAsSeen(unseen[i].newsletter_id);
        }
        commit('setNewsCount', 0);
      }
    },

  },
};
